<template>
  <div v-if="showPage">
    <div v-if="isOKbao || isOKTX" class="okbanner" :class="{ 'tx': isOKTX }">
      <img class="logo" src="@/static/images/okApp/okbao.png" alt="" srcset="" />
      <div class="content">
        <div class="content__wrap">
          <div class="item">
            <input v-model.trim="form.mobile" type="tel" placeholder="请输入手机号" />
          </div>
          <div class="item code">
            <input v-model.trim="form.code" type="tel" placeholder="请输入验证码" @input="checkCode" />
            <div class="codes" @click="getCode" :class="{ disabled: !!timer }">
              {{ !timer ? '获取验证码' : codeTxt }}
            </div>
          </div>
          <img src="@/static/images/okApp/btn.png" @click="toNext" alt="" />
          <div class="bottom-text" v-if="yhxyObj.yhxy">
            <div class="checkBox" @click="activecir = !activecir">
              <div class="btns" :class="{ active: activecir }">
                <div class="circle"></div>
              </div>
            </div>
            <div class="txtBox">
              注册手机号即代表同意
              <span @click="jumpPage(yhxyObj.yhxy)">《用户服务协议》</span>
              <!-- 、<span @click="jumpPage('/apps/public/privacy.html')">《隐私政策》</span> -->
            </div>
          </div>
        </div>
      </div>
      <img class="bottom-img" src="@static/images/okApp/2.png" alt="" />
      <validCodeModal ref="validCodeModal" @success="timerStart" :color="isOKbao || isOKTX ? 'yellow' : ''"></validCodeModal>
    </div>
    <div class="signInit" v-else-if="orgId">
      <div class="banner">
        <div class="banner-title">
          <p>仅需{{ filterStepText(stepConfig.length) }}步<br />即可在线入职</p>
        </div>
        <div class="process">
          <ul>
            <li v-for="(item, index) in stepConfig" :key="index">
              <div>
                <img :src="require(`@/static/images/sign/p${index + 1}.png`)" />
              </div>
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="list">
        <div class="item">
          <img src="@static/images/login/tel.png" />
          <input v-model.trim="form.mobile" type="tel" placeholder="请输入您的手机号码" />
        </div>
        <div class="item code">
          <img src="@static/images/login/code.png" />
          <input v-model.trim="form.code" type="tel" placeholder="请输入验证码" @input="checkCode" />
          <div class="codes" @click="getCode" :class="{ disabled: !!timer }">
            {{ !timer ? '获取验证码' : codeTxt }}
          </div>
        </div>
        <div class="btn" @click="toNext">立即入职</div>
      </div>

      <div class="bottom-text" v-if="yhxyObj.yhxy">
        <div class="checkBox" @click="activecir = !activecir">
          <div class="btns" :class="{ active: activecir }">
            <div class="circle"></div>
          </div>
        </div>
        <div class="txtBox">
          注册手机号即代表同意
          <span @click="jumpPage(yhxyObj.yhxy)">《用户服务协议》</span>
          <!-- 、<span @click="jumpPage('/apps/public/privacy.html')">《隐私政策》</span> -->
        </div>
      </div>
      <validCodeModal ref="validCodeModal" @success="timerStart"></validCodeModal>
    </div>
    <authBtn text="为了更好的向您提供服务，需要您授权获取微信昵称和头像，感谢您的支持与配合！" @close="closeAuthBtn" v-if="isOKbao || isOKTX"></authBtn>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import login from './components/login.js';
import validCodeModal from '@/components/validCodeModal';
import authBtn from '@/components/authBtn';
import wxAPI from '@/api/weixin';
export default {
  components: { validCodeModal, authBtn },
  mixins: [common, login],
  data() {
    return {
      activecir: false,
      form: {
        mobile: '',
        code: '',
        area: ''
      },
      codeTxt: '',
      num: 60,
      timer: null,
      tel: '',
      orgId: '',
      stepConfig: [],
      yhxyObj: {},
      showPage: false,
      isOKbao: false,
      isOKTX: false,
      userInfo: {},
      agentType: null
    };
  },
  computed: {
    active() {
      const { mobile, code } = this.form;
      if (mobile && code && this.activecir) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.orgId = this.$route.query.orgId;
    this.userId = this.$route.query.userId || '';
    if (!this.orgId) {
      this.$notice.alert('机构id不存在');
      return;
    }
    this.checkLogin(this.$route.query.noCheck == 1).then(res => {
      this.getStep(); //获取步骤配置
      this.$weixin.hideMenu();
    });
    this.getPdfUrl();
    wxAPI.getWxinfo(data => {
      if (data) {
        this.userInfo = data;
        this.getRecruitmentIntention();
        this.setUserinfoAjax()
      }
    });
  },
  methods: {
    saveAgentType(agentType, userAuthId) {
      return this.$http({
        type: 'POST',
        url: '/api/userAuth/saveAgentType',
        data: {
          agentType,
          userAuthId
        }
      }).then(res => {
        console.log('保存成功');
      });
    },
    // ok保账号状态判断
    getAccountStatus() {
      if (!this.$config.isApp || !this.isOKbao || !this.isOKTX) {
        return true;
      }
      return this.$http({
        type: 'POST',
        url: '/app/checkOnboarding',
        data: {
          mobile: this.form.mobile
        }
      }).then(res => {
        if (res.data == 1) {
          return true;
        } else {
          this.$notice.msg('账号异常，请联系您的销售支持');
          return false;
        }
      });
    },
    closeAuthBtn() {
      this.$weixin.jumpAuth({
        authType: 'wechat',
        state: 'snsapi_base'
      });
    },
    // 监控输入，合法时自动提交
    checkCode() {
      // 限制验证码6位，避免ios系统自动填入2次短险验证码的BUG
      if (this.form.code.length > 6) {
        this.form.code = this.form.code.slice(0, 6);
      }
      if (this.form.code.length == 6 && this.$regulars.isPhone(this.form.mobile) && this.yhxyObj.yhxy && this.activecir) {
        this.toNext();
      }
    },
    jumpPage(url) {
      if (this.$config.isApp) {
        this.$app.openWeb(url);
      } else {
        location.href = url;
      }
    },
    // 新增有意向用户增员关联
    getRecruitmentIntention() {
      this.$http({
        type: 'POST',
        url: '/app/okbao/userIncrease/addIntentional',
        data: {
          userId: this.userId,
          openId: this.userInfo.openid,
          wxIcon: this.userInfo.icon,
          wxName: this.userInfo.nickName || '好友'
        }
      });
    },
    // 获取协议链接
    getPdfUrl() {
      this.$http({
        type: 'PUT',
        url: '/api/appVersion/queryTenantVersion',
        data: {
          orgId: this.orgId
        }
      }).then(res => {
        if (res.data) {
          this.yhxyObj = res.data;
        }
      });
    },
    getStep() {
      this.$http({
        type: 'GET',
        url: '/api/userAuth/entry/steps',
        data: {
          orgId: this.orgId
        }
      }).then(res => {
        this.showPage = true;
        const merchantNo = res.data.merchantNo;
        if (this.$tools.isOKbao(merchantNo)) {
          this.isOKbao = true;
          this.$tools.setWebTitle('加入OK保');
        } else if (this.$tools.isOKTX(merchantNo)) {
          this.isOKTX = true;
          this.$tools.setWebTitle('加入OK团保');
        } else {
          this.$tools.setWebTitle('在线入职');
        }
        this.stepConfig = [
          {
            name: '登记信息',
            show: '1',
            pic: require('@/static/images/sign/p1.png')
          },
          {
            name: '人脸识别',
            show: res.data.isFaceAuth,
            pic: require('@/static/images/sign/p2.png')
          },
          {
            name: '岗前培训',
            show: res.data.isTrain,
            pic: require('@/static/images/sign/p3.png')
          },
          {
            name: '签署合同',
            show: res.data.isSignContract,
            pic: require('@/static/images/sign/p4.png')
          }
        ].filter(item => item.show * 1);
      });
    },
    filterStepText(num) {
      switch (num) {
        case 1:
          return '一';
        case 2:
          return '二';
        case 3:
          return '三';
        default:
          return '四';
      }
    },
    async getInfos() {
      if (!localStorage.regToken) {
        return;
      }
      return this.$http({
        type: 'POST',
        url: '/api/userAuth/queryregistStatus',
        data: {
          token: localStorage.regToken,
          orgId: this.orgId
        }
      });
    },
    async toNext() {
      // if (!this.active) return;
      console.log(this.form);
      if (!this.$regulars.isPhone(this.form.mobile)) {
        this.$notice.msg('请输入正确的手机号码');
        return;
      }
      if (this.form.code.length != 6) {
        this.$notice.msg('请输入6位验证码');
        return;
      }
      if (this.yhxyObj.yhxy && !this.activecir) {
        this.$notice.msg('请先阅读并勾选相关协议');
        return;
      }
      const status = await this.getAccountStatus();
      if (!status) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        data: {
          // ok保或者ok团保 限制H5页只能注册
          isRegister: (this.isOKTX || this.isOKbao) && !this.$config.isApp ? 1 : 0,
          mobile: this.form.mobile,
          mobileCode: this.form.code,
          orgId: this.orgId,
          recommenderId: this.userId,
          openId: this.userInfo.openid,
          wxIcon: this.userInfo.icon,
          wxName: this.userInfo.nickName
        },
        url: `/api/userAuth/registForSign?recommenderId=${this.userId}`,
        apiPermissionCode: 'APP_ONLINERECRUITMENT_ADD'
      })
        .then(async res => {
          localStorage.regToken = res.data.token;
          if (this.isOKbao) {
            try {
              await this.saveAgentType(1, res.data.id);
            } catch (err) {
              console.error('保存销支类型失败');
            }
          }
          if (sessionStorage.orgId) {
            localStorage['regToken' + sessionStorage.orgId] = localStorage.regToken;
          }
          if (this.isOKTX && !this.$config.isApp) {
            location.replace(this.$config.root + '/m/txokb/appDownload');
            return;
          }
          if (this.isOKbao && !this.$config.isApp) {
            location.replace(this.$config.root + '/m/260580000000800/appDownload');
            return;
          }
          if (this.isOKbao || this.isOKTX) {
            let { data } = await this.getInfos();
            console.log(data);
            if (data.auditStatus == 3) {
              this.$router.replace({
                path: this.isOKbao ? '/apps/ok-sign/result' : '/apps/sign/result',
                query: this.$route.query
              });
            } else {
              this.isOKbao ? this.jumpOKBAO(data.status) : this.jump(Number(res.data.status));
            }
          } else {
            const status = Number(res.data.status);
            this.jump(status);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    timerStart() {
      this.num = 60;
      this.codeTxt = `重新获取(${this.num}s)`;
      this.timer = setInterval(() => {
        if (this.num <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.num--;
        this.codeTxt = `重新获取(${this.num}s)`;
      }, 1000);
    },
    async getCode() {
      if (this.yhxyObj.yhxy && !this.activecir) {
        this.$notice.msg('请先阅读并勾选相关协议');
        return;
      }
      if (this.timer) return;
      if (!this.$regulars.isPhone(this.form.mobile)) {
        this.$notice.msg('请输入正确的手机号码');
        return;
      }
      const status = await this.getAccountStatus();
      if (!status) {
        return;
      }
      this.$refs.validCodeModal.open({
        requestUrl: '/api/userAuth/registCode',
        params: {
          isRegister: (this.isOKTX || this.isOKbao) && !this.$config.isApp ? 1 : 0,
          mobile: this.form.mobile,
          isRecommend: 0,
          orgId: this.orgId
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './init-new1.scss';
</style>
